import { TaskItem } from '@/entities/tasks/model/types'

export function isTaskCooledDown(task: TaskItem): boolean {
  if (!task.repeatable) {
    return false
  }
  // если еще не нажали ни разу
  if (task.next_claim_available === null) {
    return true
  }
  // если откат прошел
  if (new Date(task.next_claim_available) < new Date()) {
    return true
  }
  return false
}

export const sortByPrioritizedTasks = (tasks: TaskItem[], prioritized: string[]) => {
  const prioritySet = new Set(prioritized)

  const prioritizedPart = tasks
    .filter((task) => prioritySet.has(task.name))
    .sort((a, b) => prioritized.indexOf(a.name) - prioritized.indexOf(b.name))

  const restPart = tasks.filter((task) => !prioritySet.has(task.name))

  return [...prioritizedPart, ...restPart]
}

export const steamOnTasks = ['addSteam', 'addEpic', 'openPs5', 'openSteamOn', 'x']

export const prioritizedTasks = [
  'yesCoin',
  'tradeStormTrade',
  'tradeUpscale',
  'joinUpscale',
  'boinkersMoon',
  'joinUpscale',
  'boinkersSlut',
  'pokergram',
]

export const eventTasks = [...steamOnTasks]
export const TaskImageObject = {
  addSteam: 'steam',
  vote: 'gamedTaskIcon',
  addEpic: 'epic',
  x: 'x',
  xPost: 'x',
  updateProgress: 'updateProgress',
  gamedCommunity: 'telegram',
  gamedChat: 'telegram',
  addToHomeScreen: 'general',
  addEmoji: 'general',
  streaks: 'streaks',
  tApps: 'web3',
  boost: 'general',
  postStory: 'stories',
  friends3: 'friends',
  friends5: 'friends',
  friends1: 'friends',
  openSteamOn: 'openCase',
  openPs5: 'openCase',
  tonConnect: 'ton',
  tonTransaction: 'ton',
  steam: 'steam',
  play: 'play',
  yesCoin: 'yesCoin',
  tradeStormTrade: 'tradeStormTrade',
  tradeUpscale: 'tradeUpscale',
  boinkersMoon: 'boinkersMoon',
  boinkersSlut: 'boinkersSlut',
  pokergram: 'pokergram',
  joinUpscale: 'x',
} as const
